import Fire_base from '../../../Config/Fire_base'

const UpdateEmail = async (state) => {
    const currentUser = Fire_base.auth().currentUser
    let setReturn = {}
    await currentUser.updateEmail(state).then((res)=>{
        alert("Sukses Ganti Email Silahkan Relogin")
        setReturn=res
    })
    return setReturn
        
    
}

export default UpdateEmail